module.exports = __webpack_public_path__ + "img/picture_gzzm02@2x.eefade61.png";